import BaseAPI from './base.api';

export default class DtcAPI extends BaseAPI {
  getAll = async () => {
    const response = await this.API.get('dtc');
    return response.data;
  };
}
